import { Dialogs } from '@leverege/ui-elements';
import { AllowedReducer, Constants } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
// import { Context } from '@leverege/plugin'
// import I18N from '@leverege/i18n'
import { object } from 'prop-types';
import InitiateTransferView from "./InitiateTransferView.js";
import InitiateTransferErrorView from "./InitiateTransferErrorView.js";
const ACTION = 'initiateTransfer';
// const { t } = I18N.ns( 'recovrGeneric.ownershipTransfer' )

function getDeviceErrors(devices, objectType) {
  let numErrors = 0;
  if (objectType === 'assetLocators') {
    const assetErrors = {
      unpaired: [],
      locatorOffline: [],
      transferPending: []
    };
    for (let i = 0; i < devices.length; i++) {
      const asset = devices[i];
      if (!asset.data?.locator?.id) {
        numErrors++;
        assetErrors.unpaired.push(asset.name);
      } else {
        const locatorLastHeartbeat = asset.data?.locator?.data?.lastHeartbeat;
        if (locatorLastHeartbeat && locatorLastHeartbeat < Date.now() - 5 * 24 * 60 * 60 * 1000) {
          numErrors++;
          assetErrors.locatorOffline.push(asset.name);
        }
      }
      if (asset.data?.outgoingTransfer?.id) {
        numErrors++;
        assetErrors.transferPending.push(asset.name);
      }
    }
    return {
      deviceErrors: assetErrors,
      numErrors
    };
  }
  if (objectType === 'locator') {
    const locatorErrors = {
      paired: [],
      offline: [],
      transferPending: []
    };
    for (let i = 0; i < devices.length; i++) {
      const locator = devices[i];
      if (locator.data?.asset?.id) {
        locatorErrors.paired.push(locator.name);
        numErrors++;
      }
      if (locator.data?.outgoingTransfer?.id) {
        locatorErrors.transferPending.push(locator.name);
        numErrors++;
      }
      if (locator.data?.lastHeartbeat && locator.data?.lastHeartbeat < Date.now() - 5 * 24 * 60 * 60 * 1000) {
        locatorErrors.offline.push(locator.name);
        numErrors++;
      }
    }
    return {
      deviceErrors: locatorErrors,
      numErrors
    };
  }
  return {
    numErrors
  };
}
export default {
  id: 'action.initiateTransfer',
  name: 'Transfer Ownership',
  layout: {
    sort: 'transfers.initateTransfer',
    sectionName: 'Transfers'
  },
  matches: [{
    use: ['contextMenu'],
    path: ['organization.companies.locations.assetsLocators', 'organization.companies.locations.locators', 'location.assetsLocators', 'company.locations.assetsLocators', 'location.locators', 'company.locations.locators']
  }],
  isPrepared: context => {
    const {
      target: targets
    } = context;
    if (targets.length === 0) return true;
    const target = targets[0];
    const deviceId = target.id;
    const device = GlobalState.get().models?.lookup?.[deviceId];
    const companyId = device.data?.company?.id;
    const locationId = device.data?.location?.id;
    const resourceId = `${companyId}/${locationId}`;
    const a = AllowedReducer.get(GlobalState.get(), resourceId);
    return a[ACTION] != null;
  },
  prepare: async context => {
    const {
      target: targets
    } = context;

    // get resource id
    const target = targets[0];
    const deviceId = target.id;
    const device = GlobalState.get()?.models?.lookup?.[deviceId];
    const systemId = device.systemId;
    const orgId = device.data?.organization?.id;
    const companyId = device.data?.company?.id;
    const locationId = device.data?.location?.id;
    const resourceId = `${companyId}/${locationId}`;
    return GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      let res;
      if (orgId) {
        res = await api.interface(systemId, 'organization').obj(orgId).grp('companies').obj(companyId).grp('locations').obj(locationId).srv('ownershipTransfer').post('initiateBulkTransfer', null, {
          test: true
        });
      } else {
        res = await api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId).srv('ownershipTransfer').post('initiateBulkTransfer', null, {
          test: true
        });
      }
      dispatch({
        type: Constants.ALLOWED_SET,
        resourceId,
        action: ACTION,
        allowed: res.allowed === true
      });
      return res.allowed === true;
    });
  },
  handles: context => {
    const {
      target: targets
    } = context;
    if (targets.length === 0) return false;
    const target = targets[0];
    const deviceId = target.id;
    const device = GlobalState.get()?.models?.lookup?.[deviceId];
    const companyId = device.data?.company?.id;
    const locationId = device.data?.location?.id;
    const resourceId = `${companyId}/${locationId}`;
    const a = AllowedReducer.get(GlobalState.get(), resourceId);
    return a[ACTION] === true;
  },
  appearance: ({
    context,
    action
  }) => {
    const {
      target: targets
    } = context;
    const objectType = context.objectType;
    let deviceTerm = objectType === 'locator' ? 'Locator' : 'Equipment';
    if (targets.length > 1) deviceTerm = `${deviceTerm}s`;
    return {
      name: `Transfer Ownership of ${targets.length} ${deviceTerm}`,
      icon: 'fa-kit fa-lv-transfer-building'
    };
  },
  perform: ({
    context
  }) => {
    const {
      target: targets,
      reloadData
    } = context;
    const objectType = context.objectType;
    const devices = targets.map(target => GlobalState.get().models?.lookup[target.id]);
    const {
      numErrors,
      deviceErrors
    } = getDeviceErrors(devices, objectType);

    // disallow if a transfer has already been initated for the asset
    if (numErrors > 0) {
      Dialogs.show({
        component: InitiateTransferErrorView,
        props: {
          objectType,
          deviceErrors
        }
      });
      return;
    }
    Dialogs.show({
      component: InitiateTransferView,
      props: {
        targets,
        devices,
        objectType,
        reloadData
      }
    });
  }
};